namespace $ { $mol_style_attach( "bog/ui/toast/manager/manager.view.css",
 "[bog_ui_toast_manager] {\n\twidth: clamp(250px, 90vw, 420px);\n}\n"
) }